import React from 'react'

export const DashboardNav = (props) => {
    
    function signOut(){
        sessionStorage.removeItem('kwt');
        window.location = "/";
    }

    return (
        <>
            <div className="dashboard-nav">
                <div className="dashboard-nav-inner">
                    <ul data-submenu-title="Acciones">
                        <li className={ props.selectedMenu === 'messages' ? 'active' : ''}><a href="/messages"><i className="sl sl-icon-envelope-open"></i> Mis mensajes <span className="nav-tag messages">2</span></a></li>
                        <li className={ props.selectedMenu === 'bookings' ? 'active' : ''}><a href="/bookings"><i className="fa fa-calendar-check-o"></i> Mis reservas</a></li>
                        <li className={ props.selectedMenu === 'wallet' ? 'active' : ''}><a href="/wallet"><i className="sl sl-icon-wallet"></i> Mi saldo</a></li>
                        <li className={ props.selectedMenu === 'reviews' ? 'active' : ''}><a href="/reviews"><i className="sl sl-icon-star"></i> Mis revisiones</a></li>
                        <li className={ props.selectedMenu === 'favorites' ? 'active' : ''}><a href="/favorites"><i className="sl sl-icon-heart"></i> Mis favoritos</a></li>
                    </ul>
                    <ul data-submenu-title="Cuenta">
                        <li className={ props.selectedMenu === 'profile' ? 'active' : ''}><a href="/profile"><i className="sl sl-icon-user"></i> Mi perfil</a></li>
                        <li onClick={signOut}><a><i className="sl sl-icon-power"></i> Cerrar sesión</a></li>
                    </ul>
                </div>
            </div>
        </>
    )
}